import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Card.png'


const _withScopeId = n => (_pushScopeId("data-v-57d49efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view balance" }
const _hoisted_2 = { class: "balance__card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Card",
  class: "balance__card_bg"
}, null, -1))
const _hoisted_4 = { class: "balance__card_amount" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "burn", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "balance__card_withdraw button button-dark button-sm" }, " Вывести ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "balance__card_deposit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "67",
    height: "67",
    viewBox: "0 0 67 67",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M33.5 41.875V33.5M33.5 33.5V25.125M33.5 33.5H25.125M33.5 33.5H41.875M33.5 58.625C25.6955 58.625 21.7932 58.625 18.7151 57.35C14.6108 55.65 11.35 52.3892 9.65002 48.2849C8.375 45.2068 8.375 41.3045 8.375 33.5C8.375 25.6955 8.375 21.7932 9.65002 18.7151C11.35 14.6108 14.6108 11.35 18.7151 9.65002C21.7932 8.375 25.6955 8.375 33.5 8.375C41.3045 8.375 45.2068 8.375 48.2849 9.65002C52.3892 11.35 55.65 14.6108 57.35 18.7151C58.625 21.7932 58.625 25.6955 58.625 33.5C58.625 41.3045 58.625 45.2068 57.35 48.2849C55.65 52.3892 52.3892 55.65 48.2849 57.35C45.2068 58.625 41.3045 58.625 33.5 58.625Z",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_8 = { class: "balance__panel" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "balance__panel_title" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.01952 5H14.9805C15.8672 4.99999 16.5824 4.99999 17.1616 5.04497C17.7579 5.09129 18.2817 5.18914 18.7663 5.42386C19.5361 5.7967 20.1619 6.39163 20.5541 7.12337C20.801 7.58404 20.904 8.08197 20.9527 8.64885C20.9763 8.92316 20.9881 9.22957 20.994 9.57226C20.998 9.60321 21 9.63471 21 9.66667C21 9.69125 20.9988 9.71558 20.9965 9.73958C21 10.0398 21 10.3665 21 10.7222V13.2778C21 14.1207 21 14.8006 20.9527 15.3512C20.904 15.918 20.801 16.416 20.5541 16.8766C20.1619 17.6084 19.5361 18.2033 18.7663 18.5761C18.2817 18.8109 17.7579 18.9087 17.1616 18.955C16.5824 19 15.8672 19 14.9805 19H9.0195C8.13278 19 7.41757 19 6.8384 18.955C6.24207 18.9087 5.71828 18.8109 5.23368 18.5761C4.46392 18.2033 3.83809 17.6084 3.44588 16.8766C3.19897 16.416 3.09603 15.918 3.04731 15.3512C2.99999 14.8006 2.99999 14.1207 3 13.2777V10.7223C3 10.3665 2.99999 10.0398 3.00355 9.73958C3.0012 9.71558 3 9.69126 3 9.66667C3 9.63471 3.00203 9.6032 3.00597 9.57225C3.0119 9.22957 3.02373 8.92316 3.04731 8.64885C3.09603 8.08197 3.19897 7.58404 3.44588 7.12337C3.83809 6.39163 4.46392 5.7967 5.23368 5.42386C5.71828 5.18914 6.24207 5.09129 6.8384 5.04497C7.41757 4.99999 8.13279 4.99999 9.01952 5ZM4.63646 10.4444C4.63637 10.5443 4.63636 10.648 4.63636 10.7556V13.2444C4.63636 14.1285 4.637 14.7447 4.67823 15.2245C4.71869 15.6952 4.7941 15.9656 4.90389 16.1704C5.13922 16.6095 5.51472 16.9664 5.97657 17.1901C6.19204 17.2945 6.47651 17.3662 6.97165 17.4046C7.47634 17.4438 8.1246 17.4444 9.05455 17.4444H14.9455C15.8754 17.4444 16.5237 17.4438 17.0283 17.4046C17.5235 17.3662 17.808 17.2945 18.0234 17.1901C18.4853 16.9664 18.8608 16.6095 19.0961 16.1704C19.2059 15.9656 19.2813 15.6952 19.3218 15.2245C19.363 14.7447 19.3636 14.1285 19.3636 13.2444V10.7556C19.3636 10.648 19.3636 10.5443 19.3635 10.4444H4.63646ZM19.3306 8.88889H4.66941C4.67212 8.85025 4.67506 8.81248 4.67823 8.77552C4.71869 8.30483 4.7941 8.03441 4.90389 7.82958C5.13922 7.39053 5.51472 7.03358 5.97657 6.80987C6.19204 6.70551 6.47651 6.63382 6.97165 6.59536C7.47634 6.55616 8.1246 6.55556 9.05455 6.55556H14.9455C15.8754 6.55556 16.5237 6.55616 17.0283 6.59536C17.5235 6.63382 17.808 6.70551 18.0234 6.80987C18.4853 7.03358 18.8608 7.39053 19.0961 7.82958C19.2059 8.03441 19.2813 8.30483 19.3218 8.77552C19.3249 8.81248 19.3279 8.85025 19.3306 8.88889ZM13.6364 12.7778C13.6364 12.3482 14.0027 12 14.4545 12H16.9091C17.361 12 17.7273 12.3482 17.7273 12.7778C17.7273 13.2073 17.361 13.5556 16.9091 13.5556H14.4545C14.0027 13.5556 13.6364 13.2073 13.6364 12.7778Z",
      fill: "#ACAEAF"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Пополнить")
], -1))
const _hoisted_10 = { class: "balance__panel_container" }
const _hoisted_11 = { class: "balance__panel_counter" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.66669 8.00016C2.66669 7.63197 2.96516 7.3335 3.33335 7.3335H12.6667C13.0349 7.3335 13.3334 7.63197 13.3334 8.00016C13.3334 8.36835 13.0349 8.66683 12.6667 8.66683H3.33335C2.96516 8.66683 2.66669 8.36835 2.66669 8.00016Z",
    fill: "#15181F"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.00002 2.6665C8.36821 2.6665 8.66669 2.96498 8.66669 3.33317V7.33317L12.6667 7.33317C13.0349 7.33317 13.3334 7.63165 13.3334 7.99984C13.3334 8.36803 13.0349 8.6665 12.6667 8.6665H8.66669V12.6665C8.66669 13.0347 8.36821 13.3332 8.00002 13.3332C7.63183 13.3332 7.33335 13.0347 7.33335 12.6665V8.6665L3.33335 8.6665C2.96516 8.6665 2.66669 8.36803 2.66669 7.99984C2.66669 7.63165 2.96516 7.33317 3.33335 7.33317L7.33335 7.33317V3.33317C7.33335 2.96498 7.63183 2.6665 8.00002 2.6665Z",
    fill: "#15181F"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "balance__panel_values" }

import { onBeforeMount, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { ProfileService } from '@/services/ProfileService';
import BaseBackLink from '@/components/shared/BaseBackLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceView',
  setup(__props) {

const router = useRouter();

const valueCanBeCustom: Ref<boolean> = ref(false);
const value: Ref<number> = ref(100);

function setCustomValue(e: Event) {
	const newValue = parseInt((e.target as HTMLInputElement).value);
	value.value = Number.isNaN(newValue) ? 100 : newValue;
}

function openPay() {
	window.location.replace(
		`https://pays.burngram.com/pay?user_id=${userId.value}&amount=${value.value}`
	);
}

// Get balance
const userId: Ref<string> = ref('');
const balance: Ref<number> = ref(-1);
onBeforeMount(() => {
	ProfileService.getBalance().then((userBalance) => {
		userId.value = userBalance.user_id;
		balance.value = userBalance.wrub_balance / 100;
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseBackLink, {
      onClick: _unref(router).back
    }, {
      default: _withCtx(() => [
        _createTextVNode("Баланс")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        (balance.value !== -1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(balance.value), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("...")
            ], 64)),
        _hoisted_5
      ]),
      _hoisted_6,
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (valueCanBeCustom.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button button-md",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value--))
              }, _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(value.value), 1),
          (valueCanBeCustom.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button button-md",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (value.value++))
              }, _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "balance__panel_value",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (value.value = 50))
          }, " 50 "),
          _createElementVNode("button", {
            class: "balance__panel_value",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (value.value = 100))
          }, " 100 "),
          _createElementVNode("button", {
            class: "balance__panel_value",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (value.value = 200))
          }, " 200 "),
          _createElementVNode("button", {
            class: "balance__panel_value",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (value.value = 250))
          }, " 250 "),
          _createElementVNode("button", {
            class: "balance__panel_value",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (value.value = 300))
          }, " 300 ")
        ]),
        (valueCanBeCustom.value)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              placeholder: "Другая сумма",
              type: "number",
              onInput: setCustomValue,
              class: "balance__panel_input"
            }, null, 32))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        onClick: openPay,
        class: "button button-md button-dark"
      }, " Пополнить ")
    ])
  ]))
}
}

})